var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoStyle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.262,
    x2: 0.222,
    y2: 1.127,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb00ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-style",
    transform: "translate(-1826 -858)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 24,
    height: 24,
    transform: "translate(1826 858)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ico-style-2",
    "data-name": "ico-style",
    d: "M5.754,7.982l-.294-.728a1,1,0,0,1,.551-1.3l9.244-3.735a1,1,0,0,1,1.3.551l5.6,13.865a1,1,0,0,1-.551,1.3L12.359,21.67a1,1,0,0,1-1.3-.551l-.088-.218v.041H6.986a1,1,0,0,1-1-1v-.269L2.649,18.327a1,1,0,0,1-.551-1.3ZM7.982,18.949h2.2l-2.2-5.45ZM5.989,12.723,4.32,16.852l1.668.709ZM7.682,7.431l4.855,12.017,7.395-2.988L15.077,4.443Zm2.969,2.026a1,1,0,1,1,.551-1.3A1,1,0,0,1,10.651,9.457Z",
    transform: "translate(1825.874 858.054)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStyle);
export default __webpack_public_path__ + "static/media/ico-style.207baf1386df9e0882a46d39cc4bfb62.svg";
export { ForwardRef as ReactComponent };